module.exports = __webpack_public_path__ + "static/media/condiciones_comercializadora.ae5a1e39.pdf";